function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import { ClickTrigger as PopoverClickTrigger } from './components/ClickTrigger';
import { FocusTrigger as PopoverFocusTrigger } from './components/FocusTrigger';
import { HoverTrigger as PopoverHoverTrigger } from './components/HoverTrigger';
import { ManualTrigger as PopoverManualTrigger } from './components/ManualTrigger';
import { PopoverAlert } from './PopoverAlert';
import { PopoverConfirm } from './PopoverConfirm';
import { PopoverContainer } from './PopoverContainer';
import { SingletonPopover } from './SingletonPopover';
export function Popover(props) {
  var _props$trigger = props.trigger,
      trigger = _props$trigger === void 0 ? 'click' : _props$trigger,
      showDelay = props.showDelay,
      hideDelay = props.hideDelay,
      children = props.children,
      show = props.show,
      placement = props.placement,
      offset = props.offset,
      preventOverflow = props.preventOverflow,
      boundariesDetectionDebounce = props.boundariesDetectionDebounce,
      overflowBoundaries = props.overflowBoundaries,
      arrow = props.arrow,
      arrowOffset = props.arrowOffset,
      getArrow = props.getArrow,
      getPopper = props.getPopper,
      hideToDestroy = props.hideToDestroy,
      lazyInit = props.lazyInit,
      zIndex = props.zIndex,
      onShow = props.onShow,
      onHide = props.onHide,
      disableToggleClose = props.disableToggleClose,
      popoverClassName = props.popoverClassName,
      popoverStyle = props.popoverStyle,
      className = props.className,
      scaleAnimation = props.scaleAnimation,
      disableAnimation = props.disableAnimation,
      afterClose = props.afterClose,
      wrapperClassName = props.wrapperClassName,
      popoverId = props.popoverId,
      getPopupContainer = props.getPopupContainer,
      extra = _objectWithoutProperties(props, ["trigger", "showDelay", "hideDelay", "children", "show", "placement", "offset", "preventOverflow", "boundariesDetectionDebounce", "overflowBoundaries", "arrow", "arrowOffset", "getArrow", "getPopper", "hideToDestroy", "lazyInit", "zIndex", "onShow", "onHide", "disableToggleClose", "popoverClassName", "popoverStyle", "className", "scaleAnimation", "disableAnimation", "afterClose", "wrapperClassName", "popoverId", "getPopupContainer"]);

  var triggerOpts = _objectSpread({
    className: className,
    disableToggleClose: disableToggleClose
  }, extra);

  var popoverOpts = {
    show: show,
    placement: placement,
    offset: offset,
    preventOverflow: preventOverflow,
    boundariesDetectionDebounce: boundariesDetectionDebounce,
    overflowBoundaries: overflowBoundaries,
    arrow: arrow,
    arrowOffset: arrowOffset,
    getArrow: getArrow,
    getPopper: getPopper,
    hideToDestroy: hideToDestroy,
    lazyInit: lazyInit,
    zIndex: zIndex,
    onShow: onShow,
    onHide: onHide,
    popoverStyle: popoverStyle,
    popoverClassName: popoverClassName,
    scaleAnimation: scaleAnimation,
    disableAnimation: disableAnimation,
    afterClose: afterClose,
    popoverId: popoverId,
    wrapperClassName: wrapperClassName,
    getPopupContainer: getPopupContainer
  };
  return React.createElement(SingletonPopover, Object.assign({}, popoverOpts), trigger === 'click' && React.createElement(PopoverClickTrigger, Object.assign({}, triggerOpts), children), trigger === 'focus' && React.createElement(PopoverFocusTrigger, Object.assign({}, triggerOpts), children), trigger === 'hover' && React.createElement(PopoverHoverTrigger, Object.assign({}, triggerOpts, {
    showDelay: showDelay,
    hideDelay: hideDelay
  }), children), trigger === 'manual' && React.createElement(PopoverManualTrigger, Object.assign({}, triggerOpts, {
    show: show
  }), children));
}
Popover.Confirm = PopoverConfirm;
Popover.Alert = PopoverAlert;
Popover.Container = PopoverContainer;
Popover.Singleton = SingletonPopover;
Popover.ClickTrigger = PopoverClickTrigger;
Popover.HoverTrigger = PopoverHoverTrigger;
Popover.FocusTrigger = PopoverFocusTrigger;
Popover.ManualTrigger = PopoverManualTrigger;